import { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { InputRef } from "antd";
import classNames from "classnames";

import { UISearchInput } from "@/shared/ui/ui-search-input";

import { MenuItem } from "../types";

export const PopoverContent = ({
	menuList,
	search,
	setSearch,
	onMenuItemClick,
	popoverWidth = 120,
}: {
	menuList: MenuItem[];
	search: string;
	setSearch: (value: string) => void;
	onMenuItemClick: () => void;
	popoverWidth?: number;
}) => {
	const inputRef = useRef<InputRef>(null);

	useEffect(() => {
		inputRef.current?.focus({ cursor: "end" });
	}, []);

	return (
		<div className="flex flex-col gap-2" style={{ width: popoverWidth }}>
			<UISearchInput value={search} setSearchValue={setSearch} ref={inputRef} delay={200} />

			<div className="flex flex-col overflow-y-auto max-h-[200px]">
				{menuList.map(({ value, label, redirectPath }) => {
					if (!label || !redirectPath) return null;

					return (
						<NavLink
							key={value}
							className={({ isActive }) =>
								classNames(
									"py-[5px] px-12 rounded-4 transition-colors hover:bg-ant-color-bg-text-hover hover:text-ant-color-text",
									{
										"bg-ant-color-primary-bg font-semibold hover:bg-ant-color-primary-bg": isActive,
									}
								)
							}
							to={redirectPath}
							onClick={onMenuItemClick}
						>
							{label}
						</NavLink>
					);
				})}
			</div>
		</div>
	);
};
